export default __webpack_public_path__ + "static/media/CNo.72-7.3901ee51.jpg";